import { DataServer } from "../../../../sensorconfig.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toggleLoading } from "../../LoadingSlice";

interface AverageSpeedByMheState {
  AverageSpeedByMhe: {
    load: boolean;
    data: [];
  };
}

export const AverageSpeedByMheSlice = createSlice({
  name: "AverageSpeedByMhe",
  initialState: {
    AverageSpeedByMhe: {
      load: false,
      data: [],
    },
  } as AverageSpeedByMheState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder      
      .addCase(getAverageSpeedByMHE.pending, (state: AverageSpeedByMheState) => {
        state.AverageSpeedByMhe.load = true;
      })
      .addCase(getAverageSpeedByMHE.fulfilled, (state: AverageSpeedByMheState, action: any) => {
        state.AverageSpeedByMhe.data = action.payload;
        state.AverageSpeedByMhe.load = false;
      })
      .addCase(getAverageSpeedByMHE.rejected, (state: AverageSpeedByMheState) => {
        state.AverageSpeedByMhe.load = false;
      });
  },
});

export default AverageSpeedByMheSlice.reducer;

export const getAverageSpeedByMHE = createAsyncThunk(
    "AverageSpeedByMhe/getAverageSpeedByMHE",
    async (param: {apiParam: { company_id: any, warehouse_id: any, duration: any }}, thunkAPI) => {
      try {
        thunkAPI.dispatch(toggleLoading());
        const { data } = await DataServer.get("/api/management/v1/getAverageSpeedByMHE?company_id=" + param.apiParam.company_id + "&warehouse_id=" + param.apiParam.warehouse_id + "&duration=" + param.apiParam.duration);
        thunkAPI.dispatch(toggleLoading());
  
        return data.data;
      } catch (error) {
        thunkAPI.dispatch(toggleLoading());
      }
    }
);